import { createFileRoute } from "@tanstack/react-router";
import { AssistenteVisualizarAcoesPage } from "@/paginas/pg_assistente/assistente-visualizar-acoes";

export const Route = createFileRoute("/_authenticated/assistente-visualizar-acoes")({
  component: AssistenteVisualizarAcoesPage,
});
